import React, {Component} from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {bindActionCreators} from "redux";
import {searchDiscountReasons, updateDiscountReasonVisibility} from "./actions";
import ListView from "../common/ListView";
import {Icon, notification} from 'antd';
import {Link} from "react-router-dom";
import MoneyDisplay from "../common/MoneyDisplay";
import {roundAmount} from "../utils/money";

class DiscountReasonsPage extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    /* state */
    search: PropTypes.object.isRequired,
    /* actions */
    searchDiscountReasons: PropTypes.func.isRequired,
    updateDiscountReasonVisibility: PropTypes.func.isRequired,
    // showDeleteDiscountReasonModal: PropTypes.func.isRequired,
  };

  onVisibilityClick = async(values) => {
    try {
      await this.props.updateDiscountReasonVisibility(values);
      this.listView.refresh();
    } catch (err) {
      notification.error({
        message: 'Failed changing visibility',
        description: err.message,
      });
    }
  };

  render() {
    const {
      history, searchDiscountReasons,
      search: {searching, pagination, filters, sorter, searchFilter, results},
    } = this.props;
    const columns = [
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        sorter: true
      },
      {
        title: 'Visibility',
        key: 'visibility',
        render: (value, {discountReasonId, visibleOnTill}) =>
          <Icon
            type="shopping-cart"
            style={{color: visibleOnTill ? 'green' : 'red', cursor: 'pointer'}}
            onClick={() => this.onVisibilityClick({discountReasonId, visibleOnTill: !visibleOnTill})}
          />
      },
      {
        title: 'Default Rate',
        dataIndex: 'defaultRate',
        key: 'defaultRate',
        render: (defaultRate, {defaultRateType}) => {
          switch (defaultRateType) {
            case 'percentage': return `${roundAmount(defaultRate)}%`;
            case 'flat': return <MoneyDisplay amount={defaultRate}/>;
            default: return 'Invalid!';
          }
        },
      },
      {
        title: 'Action',
        key: 'action',
        render: (_, discountReason) => {
          const encodedId = encodeURIComponent(discountReason.discountReasonId);
          return <Link to={`/discount-reason/update/${encodedId}`}>Edit</Link>
          //     return <span><Link to={`/discount-reason/update/${encodedId}`}>Edit</Link> | <a
          //       onClick={() => this.props.showDeleteDiscountReasonModal(discountReason)}>Delete</a> </span>
        }
      }
    ];
    // {deleteDiscountReasonModalVisible && <DeleteDiscountReasonFormModal onDelete={() => this.listView.refresh()}/>}
    return (
      <ListView
        ref={ref => this.listView = ref}
        title="Discount Reasons"
        loading={searching}
        columns={columns}
        dataSourceProvider={searchDiscountReasons}
        dataSource={results}
        pagination={pagination}
        searchFilter={searchFilter}
        filters={filters}
        sorter={sorter}
        onAdd={() => history.push('/discount-reason/add')}
        rowKey="discountReasonId"
      />
    );
  }
}

const mapStateToProps = state => ({
  loading: state.discountReason.discountReasonsLoading || state.discountReason.updatingDiscountReasonVisibility,
  search: state.discountReason.search,
  // deleteDiscountReasonModalVisible: state.discountReason.deleteDiscountReasonModalVisible,
});

const mapDispatchToProps = dispatch => (bindActionCreators({
  searchDiscountReasons,
  updateDiscountReasonVisibility,
  // showDeleteDiscountReasonModal,
}, dispatch));

export default connect(mapStateToProps, mapDispatchToProps)(DiscountReasonsPage);



// WEBPACK FOOTER //
// ./src/DiscountReason/DiscountReasonsPage.js